import { storageKey } from "./storage-keys";
import { storageService } from "./storage-service";

export const getJWTToken = () => {
  return storageService.getItemAsObject(storageKey.token);
};
